// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"sidebar_sidebarWrapper__sPsJf","item":"sidebar_item__Y6FRl","addOgrangecolor":"sidebar_addOgrangecolor__Z5GHz"};